import { Flex, Button, useColorModeValue, Text, Select, FormLabel, Icon } from '@chakra-ui/react'
import Card from 'components/card/Card'
import { useEffect, useRef, useState } from 'react';
import { MdInsights } from 'react-icons/md';
import { useData } from 'services/data/DataProvider';
import StratStats from 'views/trader/strategies/components/StratStats';
import { newTradeLogic, StatStrat, Trade, TradeLogic, UserTradeLogic } from 'views/trader/trades/variables/types';
import { LogicStats } from '../variables/LogicStatData';
import ShowTradesModal from 'views/trader/components/ShowTradesModal';

const TradeLogicPanel = (props: { usedlogic: UserTradeLogic }) => {

    const { usertrades, defaultcurrency } = useData();

    const [loading, setLoading] = useState(false);
    const tradesModalRef = useRef(null);

    //const toast = useToast();

    const textColor = useColorModeValue('secondaryGray.900', 'white');
    const textColorSecondary = useColorModeValue('secondaryGray.700', 'secondaryGray.500');
    const bgcolor = useColorModeValue('white', 'navy.900');

    const [selectedlogic, setSelectedLogic] = useState<TradeLogic>(newTradeLogic());
    const [filteredTrades, setFilteredTrades] = useState<Trade[]>([]);

    const [logicstats, setLogicstats] = useState({ wcount: 0, wperc: 0, wavg: 0, wmax: 0, wtotal: 0, wavgscore: 0, lcount: 0, lperc: 0, lavg: 0, lmax: 0, ltotal: 0, lavgscore: 0 });

    let logicopy = JSON.parse(JSON.stringify(selectedlogic));

    useEffect(() => {
        LogicStats(filteredTrades, defaultcurrency).then((res: StatStrat) => {
            setLogicstats(res);
        })
    }, [filteredTrades]);
    useEffect(() => {
        processSelection();
    }, [selectedlogic, usertrades]);

    const updatevariable = async (category: string, val: string) => {
        switch (category) {
            case 'market_condition':
                logicopy.market_condition = val;
                break;
            case 'key_level':
                logicopy.key_level = val;
                break;
            case 'htf':
                logicopy.htf = val;
                break;
            case 'htf_trend':
                logicopy.htf_trend = val;
                break;
            case 'etf':
                logicopy.etf = val;
                break;
            case 'entry':
                logicopy.entry = val;
                break;
            case 'stop':
                logicopy.stop = val;
                break;
            case 'target':
                logicopy.target = val;
                break;
        }
        setSelectedLogic(logicopy);
    }
    const clearVariables = () => {
        setSelectedLogic(newTradeLogic());
        setLogicstats({ wcount: 0, wperc: 0, wavg: 0, wmax: 0, wtotal: 0, wavgscore: 0, lcount: 0, lperc: 0, lavg: 0, lmax: 0, ltotal: 0, lavgscore: 0 })
        setFilteredTrades([]);
    }

    const processSelection = () => {

        /*if (loaded && emptylogic()) {
            toast({ title: 'No variables selected ...', description: "Select variables to filter trades", status: 'info', position: 'top', duration: 2000, isClosable: true })
        }*/

        setLoading(true)


        let trades: Trade[] = usertrades.filter((t: Trade) =>
            t.trade_logic && t.trade_logic.length > 0
        )

        let filter_trades: Trade[] = [];

        let arr: string[] = [];

        Object.entries(selectedlogic).forEach(([key, value]) => {
            if (value !== '') {
                arr.push(key);
            }
        });

        ///// CHECK THIS IS WORKING PROPERLY AGAIN LATER

        for (let tr of trades) {
            let tl = tr.trade_logic[0];
            let tstr = '';
            let astr = '';
            for (let a of arr) {
                switch (a) {
                    case 'market_condition':
                        tstr += tl.market_condition;
                        astr += selectedlogic.market_condition;
                        break;
                    case 'key_level':
                        tstr += tl.key_level;
                        astr += selectedlogic.key_level;
                        break;
                    case 'htf':
                        tstr += tl.htf;
                        astr += selectedlogic.htf;
                        break;
                    case 'htf_trend':
                        tstr += tl.htf_trend;
                        astr += selectedlogic.htf_trend;
                        break;
                    case 'etf':
                        tstr += tl.etf;
                        astr += selectedlogic.etf;
                        break;
                    case 'entry':
                        tstr += tl.entry;
                        astr += selectedlogic.entry;
                        break;
                    case 'stop':
                        tstr += tl.stop;
                        astr += selectedlogic.stop;
                        break;
                    case 'target':
                        tstr += tl.target;
                        astr += selectedlogic.target;
                        break;
                }
            }
            if (astr.trim() !== '' && tstr.trim() === astr.trim()) {
                filter_trades.push(tr);
            }
        }

        setFilteredTrades(filter_trades);
        setLoading(false);

    }

    const showTrades = () => {
        tradesModalRef.current.openModal(filteredTrades, "Filtered Trades", '');
    }
    const emptylogic = () => {
        return selectedlogic.market_condition === '' &&
            selectedlogic.key_level === '' &&
            selectedlogic.htf === '' &&
            selectedlogic.htf_trend === '' &&
            selectedlogic.etf === '' &&
            selectedlogic.entry === '' &&
            selectedlogic.stop === '' &&
            selectedlogic.target === '';
    }

    return (
        <Card borderWidth={'1px'} bg='transparent' h='100%'>
            <Flex>
                <FormLabel fontWeight='bold' fontSize='md' mb='8px' color={textColor} mt='-32px' bg={bgcolor} px='10px'>Trade Logic</FormLabel>
            </Flex>
            <Flex>
                <FormLabel fontWeight='bold' fontSize='sm' mb='8px' mt='20px' color={textColorSecondary} bg={bgcolor} px='10px'>Select combination of variables to filter trades</FormLabel>
            </Flex>

            <Flex direction={{ base: 'column', md: 'row' }} gap={5} >
                <Flex direction={'column'} gap={3} justify={'center'} mt='20px' w={{ base: '100%', md: '50%' }}>
                    <Flex direction={'row'} align={'center'}>
                        <Button w='280px' variant={'outline'} borderRadius={'5px'} fontWeight={'500'} justifyContent={'start'} borderWidth={'2px'} color='gray' me='10px' isLoading={loading} loadingText="Loading"><Text color='gray'>Market conditions</Text></Button>
                        {props.usedlogic.market_condition.length > 0 ? (
                            <Select variant={'flushed'} value={selectedlogic.market_condition} onChange={(e) => { updatevariable('market_condition', e.target.value) }} color={selectedlogic.market_condition === '' ? '' : 'blue.500'} fontWeight={selectedlogic.market_condition === '' ? '' : '700'}>
                                <option value=''>Select ...</option>
                                {props.usedlogic.market_condition.map((val: string) => (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Text color={'red.500'} fontWeight={'700'}>No data</Text>
                        )}
                    </Flex>
                    <Flex direction={'row'} align={'center'}>
                        <Button w='280px' variant={'outline'} borderRadius={'5px'} fontWeight={'500'} justifyContent={'start'} borderWidth={'2px'} color='gray' me='10px' isLoading={loading} loadingText="Loading"><Text color='gray'>Recent key level</Text></Button>
                        {props.usedlogic.key_level.length > 0 ? (
                            <Select variant={'flushed'} value={selectedlogic.key_level} onChange={(e) => { updatevariable('key_level', e.target.value) }} color={selectedlogic.key_level === '' ? '' : 'blue.500'} fontWeight={selectedlogic.key_level === '' ? '' : '700'}>
                                <option value=''>Select ...</option>
                                {props.usedlogic.key_level.map((val: string) => (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Text color={'red.500'} fontWeight={'700'}>No data</Text>
                        )}
                    </Flex>
                    <Flex direction={'row'} align={'center'}>
                        <Button w='280px' variant={'outline'} borderRadius={'5px'} fontWeight={'500'} justifyContent={'start'} borderWidth={'2px'} color='gray' me='10px' isLoading={loading} loadingText="Loading"><Text color='gray'>Higher timeframe</Text></Button>
                        {props.usedlogic.htf.length > 0 ? (
                            <Select variant={'flushed'} value={selectedlogic.htf} onChange={(e) => { updatevariable('htf', e.target.value) }} color={selectedlogic.htf === '' ? '' : 'blue.500'} fontWeight={selectedlogic.htf === '' ? '' : '700'}>
                                <option value=''>Select ...</option>
                                {props.usedlogic.htf.map((val: string) => (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Text color={'red.500'} fontWeight={'700'}>No data</Text>
                        )}
                    </Flex>
                    <Flex direction={'row'} align={'center'}>
                        <Button w='280px' variant={'outline'} borderRadius={'5px'} fontWeight={'500'} justifyContent={'start'} borderWidth={'2px'} color='gray' me='10px' isLoading={loading} loadingText="Loading"><Text color='gray'>HTF trend</Text></Button>
                        {props.usedlogic.htf_trend.length > 0 ? (
                            <Select variant={'flushed'} value={selectedlogic.htf_trend} onChange={(e) => { updatevariable('htf_trend', e.target.value) }} color={selectedlogic.htf_trend === '' ? '' : 'blue.500'} fontWeight={selectedlogic.htf_trend === '' ? '' : '700'}>
                                <option value=''>Select ...</option>
                                {props.usedlogic.htf_trend.map((val: string) => (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Text color={'red.500'} fontWeight={'700'}>No data</Text>
                        )}
                    </Flex>
                    <Flex direction={'row'} align={'center'}>
                        <Button w='280px' variant={'outline'} borderRadius={'5px'} fontWeight={'500'} justifyContent={'start'} borderWidth={'2px'} color='gray' me='10px' isLoading={loading} loadingText="Loading"><Text color='gray'>Entry timeframe</Text></Button>
                        {props.usedlogic.etf.length > 0 ? (
                            <Select variant={'flushed'} value={selectedlogic.etf} onChange={(e) => { updatevariable('etf', e.target.value) }} color={selectedlogic.etf === '' ? '' : 'blue.500'} fontWeight={selectedlogic.etf === '' ? '' : '700'}>
                                <option value=''>Select ...</option>
                                {props.usedlogic.etf.map((val: string) => (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Text color={'red.500'} fontWeight={'700'}>No data</Text>
                        )}
                    </Flex>
                    <Flex direction={'row'} align={'center'}>
                        <Button w='280px' variant={'outline'} borderRadius={'5px'} fontWeight={'500'} justifyContent={'start'} borderWidth={'2px'} color='gray' me='10px' isLoading={loading} loadingText="Loading"><Text color='gray'>Entry signal/level</Text></Button>
                        {props.usedlogic.entry.length > 0 ? (
                            <Select variant={'flushed'} value={selectedlogic.entry} onChange={(e) => { updatevariable('entry', e.target.value) }} color={selectedlogic.entry === '' ? '' : 'blue.500'} fontWeight={selectedlogic.entry === '' ? '' : '700'}>
                                <option value=''>Select ...</option>
                                {props.usedlogic.entry.map((val: string) => (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Text color={'red.500'} fontWeight={'700'}>No data</Text>
                        )}
                    </Flex>
                    <Flex direction={'row'} align={'center'}>
                        <Button w='280px' variant={'outline'} borderRadius={'5px'} fontWeight={'500'} justifyContent={'start'} borderWidth={'2px'} color='gray' me='10px' isLoading={loading} loadingText="Loading"><Text color='gray'>Initial stop logic</Text></Button>
                        {props.usedlogic.stop.length > 0 ? (
                            <Select variant={'flushed'} value={selectedlogic.stop} onChange={(e) => { updatevariable('stop', e.target.value) }} color={selectedlogic.stop === '' ? '' : 'blue.500'} fontWeight={selectedlogic.stop === '' ? '' : '700'}>
                                <option value=''>Select ...</option>
                                {props.usedlogic.stop.map((val: string) => (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Text color={'red.500'} fontWeight={'700'}>No data</Text>
                        )}
                    </Flex>
                    <Flex direction={'row'} align={'center'}>
                        <Button w='280px' variant={'outline'} borderRadius={'5px'} fontWeight={'500'} justifyContent={'start'} borderWidth={'2px'} color='gray' me='10px' isLoading={loading} loadingText="Loading"><Text color='gray'>Target logic</Text></Button>
                        {props.usedlogic.target.length > 0 ? (
                            <Select variant={'flushed'} value={selectedlogic.target} onChange={(e) => { updatevariable('target', e.target.value) }} color={selectedlogic.target === '' ? '' : 'blue.500'} fontWeight={selectedlogic.target === '' ? '' : '700'}>
                                <option value=''>Select ...</option>
                                {props.usedlogic.target.map((val: string) => (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                ))}
                            </Select>
                        ) : (
                            <Text color={'red.500'} fontWeight={'700'}>No data</Text>
                        )}
                    </Flex>
                    
                </Flex>
                <Flex w={{ base: '100%', md: '50%' }} direction={'column'}>
                    <StratStats loading={loading} stats={logicstats} currency={defaultcurrency} />
                </Flex>
            </Flex>
            <Flex justify={'center'} mt='20px' gap={2}>
                        <Button variant={'ghost'} onClick={clearVariables}>Clear selection</Button>
                        <Button hidden={filteredTrades.length<1} variant={'outline'} colorScheme={'blue'} onClick={showTrades} >View trades<Icon boxSize={5} ms='10px' as={MdInsights} /></Button>
                    </Flex>
            <ShowTradesModal ref={tradesModalRef} />
        </Card>
    )
}

export default TradeLogicPanel
